
import React, { useState } from 'react';
function WebDev() {
  const [activeAccordion, setActiveAccordion] = useState('collapseOne');

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? '' : id);
  };

    return (
    <>
      {/* Hero Area */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Website Development</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> 
                  <span>Website Development</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Service Sidebar Area */}
      <div className="service-sidebar-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="service2-widget-sidebar" style={{padding: '0 !important'}}>
                <div className="img1 reveal image-anime">
                  <img src="assets/img/all-images/service/service-img6.png" alt="" />
                </div>
                <div className="space32"></div>
                <h3>Website Development</h3>
                <div className="space20"></div>
                <p>
                  Web application development is a growing industry, and there are a number of reasons for that. First of all, it’s a great way to create customized and interactive websites.
                </p>
                <div className="space14"></div>
                
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Secure & Scalable Architecture</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>E-commerce & CMS Solutions</b>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Custom Web Application Development</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Responsive & Mobile-Friendly Design</b>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="space32"></div>
                <div className="pera-box">
                  {/* <h4>Safeguard Your Business With Advanced Cybersecurity</h4> */}
                  <div className="space12"></div>
                  <p>
                   For starters, custom web applications offer a unique way to improve your business. By creating a custom web application, you can increase efficiency and streamline your operations. You can also use a web application to build a CRM or e-commerce platform. This way, you can manage your customers and sales more effectively. And finally, web application development can help you create an ERP system. This is a great way to manage all your business finances and data.
                  </p>
                </div>
                
                <div className="space18"></div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img5.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img7.png" alt="" />
                    </div>
                  </div>
                </div>
                
                <div className="space32"></div>
                <h3>What We Provide</h3>
<div class="space20"></div>
<ul className="check-list">
  <li>
  <b> Customized & Interactive Websites </b> – Build tailored solutions that engage users.
  </li>
  <li>
    <b>CRM Applications</b> – Manage and strengthen customer relationships effectively.
  </li>
  <li>
    <b>E-commerce Solutions</b> – Create online stores with seamless shopping experiences.
  </li>
  <li>
    <b>ERP Applications</b> – Streamline and integrate business processes efficiently.
  </li>
  <li>
    <b>Unique Services</b> – Offer specialized functionality through custom websites.
  </li>
  <li>
    <b>Customer Management</b> – Easily handle customer data and interactions with the right tools.
  </li>
  <li>
    <b>Strong Online Presence</b> – Establish brand visibility and credibility online.
  </li>
  <li>
   <b>Business Growth</b> – Attract more customers and improve operations through web applications.
  </li>
</ul>


                
                <div className="space48"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default WebDev
